import './dayosense/style';
import FormStructure from './dayosense/form_structure';

export default FormStructure;